import { theme, ThemePaths } from "../../theme";

export const getMenuItemStyles = (themePath: ThemePaths = "default") => ({
  "&:hover": {
    background: theme.backgrounds.primarySelection,
    color: theme[themePath].colors.textPrimary.primary,
  },
  color: theme[themePath].colors.textPrimary.secondary,
});
